import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
              天美麻花星空影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-500"
                  : scrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white hover:text-primary-300"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? "text-primary-500"
                    : scrolled
                    ? "text-foreground-700 hover:text-primary-500"
                    : "text-white hover:text-primary-300"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/about"
                  ? "text-primary-500"
                  : scrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white hover:text-primary-300"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"} ${scrolled ? "text-foreground-900" : "text-white"}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500">首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}